import endpoint from "../../config/endpoints";

export const OutletProspectiveStatusJson = {
    screenTitle: "Outlet Status",
    showSaveNextBtn: true,
    searchList: [
        {
            label: "Region",
            controlType: "autocomplete",
            placeHolder: "Select Region",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            masterName: "regionDetail",
            dataKey: "region",
            getListId: "region",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "State",
            controlType: "autocomplete",
            placeHolder: "Select State",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            masterName: "stateDetail",
            dataKey: "state",
            getListFrom: "region",
            getListId: "state",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Zone",
            controlType: "autocomplete",
            placeHolder: "Select Zone",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            masterName: "zoneDetail",
            dataKey: "zone",
            getListFrom: "state",
            getListId: "zone",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "District",
            controlType: "autocomplete",
            placeHolder: "Select District",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            masterName: "districtDetail",
            dataKey: "district",
            getListFrom: "zone",
            getListId: "district",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Taluka",
            controlType: "autocomplete",
            placeHolder: "Select Taluka",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            masterName: "talukaDetail",
            dataKey: "taluka",
            getListFrom: "district",
            getListId: "taluka",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Area",
            controlType: "autocomplete",
            placeHolder: "Select Area",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            masterName: "areaDetail",
            dataKey: "areaIds",
            getListFrom: "taluka",
            getListId: "areaIds",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Beat",
            controlType: "multiSelect",
            placeHolder: "Select Beat",
            md: 12,
            lg: 12,
            sm: 12,
            xs: 12,
            labelSM: 1,
            labelMD: 1,
            labelLG: 1,
            valueSM: 11,
            valueMD: 11,
            valueLG: 11,
            dataKey: "beat",
            masterName: "beatDetail",
            getListFrom: "areaIds",
            getListId: "beat",
            isMandatory: true,
            isRootLevelKey: true,
        },
    ],

    searchListForManager: [
        {
            label: "Area",
            controlType: "autocomplete",
            placeHolder: "Select Area",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            masterName: "areaDetail",
            dataKey: "areaIds",
            getListId: "areaIds",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Beat",
            controlType: "multiSelect",
            placeHolder: "Select Beat",
            md: 12,
            lg: 12,
            sm: 12,
            xs: 12,
            labelSM: 1,
            labelMD: 1,
            labelLG: 1,
            valueSM: 11,
            valueMD: 11,
            valueLG: 11,
            dataKey: "beat",
            masterName: "beatDetail",
            getListFrom: "areaIds",
            getListId: "beat",
            isMandatory: true,
            isRootLevelKey: true,
        },
    ],
};
